class ImageUpload
{

    activate(el, url, imagesSelector, clickableElements, progressElements)
    {
        if (typeof el.dz == "undefined") {
            let images = jQuery(imagesSelector);
            progressElements = jQuery(progressElements);
            el.dz = new Dropzone(el, {
                url: url,
                createImageThumbnails: false,
                clickable: clickableElements,
                previewTemplate: null,
                acceptedFiles: "image/*",
                uploadMultiple: true,
                parallelUploads: 40,
                maxFiles: 40,
                timeout: false,
                addedfile(result)
                {
                    if (progressElements) {
                        progressElements.addClass("running");
                    }
                },
                uploadprogress(result, progress, bytesSent)
                {
                    if (progressElements) {
                        progressElements.css({
                            width: parseInt(progress) + "%"
                        });
                        progressElements.html(parseInt(progress) + "%&nbsp;");
                    }
                },
                success(data, result)
                {
                    if (result.status) {
                        if (progressElements) {
                            progressElements.css("width", "").removeClass("running").addClass("success");
                            setTimeout(function () {
                                progressElements.removeClass("success");
                            }, 500);
                        }
                        if (images) {
                            if (imagesSelector === '.user-profile-image') {
                                app.userProfile.updateProfileImages(result.image);
                            } else {
                                app.userProfile.updateBackgroundImages(result.image);
                            }
                            if (document.querySelector('#gallery')) {
                                app.ajax.reload('#gallery');
                            }
                        }
                        if (typeof result.callback == "string") {
                            eval(result.callback);
                        }
                    } else {
                        if (progressElements) {
                            progressElements.css("width", "").removeClass("running").addClass("failure");
                            setTimeout(function () {
                                progressElements.removeClass("failure");
                            }, 3000);
                        }
                    }
                },
                error(data, error)
                {
                    app.alert.error(app.config.stdError.title, error);
                    if (progressElements) {
                        progressElements.css("width", "").removeClass("running").addClass("failure");
                        setTimeout(function () {
                            progressElements.removeClass("failure");
                        }, 3000);
                    }
                }
            });
        }
    }

}